<h2 mat-dialog-title>Add the reasons why the payment is being rejected</h2>
<form [formGroup]="form" (ngSubmit)="submit()">
  <mat-dialog-content>
    <mat-form-field appearance="fill" style="width:100%">
      <textarea matInput
                formControlName="note"
                placeholder="Type your message here"
                rows="4"></textarea>
      <mat-error *ngIf="form.controls.note.hasError('required')">
        A reason is required
      </mat-error>
    </mat-form-field>
  </mat-dialog-content>

    <div class="actions-row">
    <button  class="gts-btn-primary-outline" matRipple (click)="dialogRef.close(null)">Cancel</button>
    <button  class="gts-btn-primary-outline" matRipple [disabled]="form.invalid">
      Submit
    </button>
  </div>

</form>
